import { graphql, useFragment } from 'react-relay';
import { isPriceRangeOrLower } from './helpers';
import { useIsRareFind_item$key } from './__generated__/useIsRareFind_item.graphql';

export function useIsRareFind(itemRef: useIsRareFind_item$key): boolean {
    const { isAuctionEnabled, similarRecentlySoldItemsPrices } = useFragment(
        graphql`
            fragment useIsRareFind_item on Item {
                isAuctionEnabled
                similarRecentlySoldItemsPrices(currency: $currency) {
                    priceRange
                }
            }
        `,
        itemRef
    );

    const isInRareFindPriceRange = isPriceRangeOrLower(
        similarRecentlySoldItemsPrices?.priceRange || null,
        'LOWER_RANGE'
    );

    return !isAuctionEnabled && isInRareFindPriceRange;
}
